import React from "react";
import { useHistory, useLocation } from "react-router-dom";

interface PopularSportsProps {
  title: string;
  items: {
    title: string;
    link: string;
  }[];
}

const PopularSports = ({
  title,
  items,
}: PopularSportsProps)  => {
  const history = useHistory();
  const location = useLocation();


  return (
    <div className="bet-popular bg-[var(--surface-card)] !border !border-[var(--border-subtle)] rounded-[var(--radius-card)] w-[260px] shrink-0 shadow-[var(--shadow-1)]" style={{ padding: 12 }}>
      <p className="text-[var(--text-primary)] font-semibold" style={{ fontSize: 16, lineHeight: 1.2, marginBottom: 12 }}>{title}</p>
      <div className="flex flex-col" style={{ gap: 2 }}>
        {items.map((item) => {
          const isAnyActive = items.some((i) => i.link === location.pathname + location.search + location.hash);
            const isActive = isAnyActive
            ? item.link === location.pathname + location.search + location.hash
            : items[0].link === item.link;

          return (
            <div
              key={item.link}
              className={`flex items-center h-[34px] px-[10px] w-full rounded-[var(--radius-sm)] text-[13px] cursor-pointer transition-colors ${
                isActive
                  ? "bg-[var(--gold-a12)] text-[var(--gold-400)] font-semibold"
                  : "text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
              }`}
              onClick={() => {
                history.push(item.link)
              }}
            >
              {item?.title}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PopularSports;
